import * as PIXI from "pixi.js";
import PIXISpine from "Plugins/pixi-spine";

import StewardParticle from "Game/PixiCores/Particles/Steward/StewardParticle";
import { Tween, Tweener } from "Classes/Tween";
import * as Sentry from "@sentry/react";

let character = {
  controller: {},
  scale: 0.22,
  sequence: {
    idle: [{ name: "Idle", loop: true }],
    move: [{ name: "Move", loop: true }],
    charge: [
      { name: "Charge", loop: false },
      { name: "Charging Loop", loop: true, delay: 0 },
    ],
    attack: [
      { name: "Attack", loop: false },
      { name: "Idle", loop: true, delay: 0 },
    ],
    attackOnce: [
      { name: "Idle", loop: false },
      { name: "Charge", loop: false, delay: 0 },
      { name: "Attack", loop: false, delay: 0 },
      { name: "Idle", loop: true, delay: 0 },
    ],
    hit: [
      { name: "Idle", loop: true },
      { name: "Hit", loop: false, delay: 0.15 },
      { name: "Idle", loop: true, delay: 0 },
    ],
    win: [{ name: "Win", loop: true, delay: 0 }],
    lose: [{ name: "Lose", loop: false }],
  },
  event: {
    Attack: () => {
      // character.controller.setAttackTo(character.controller.targetPosition);
    },
  },
  eventListener: {
    event: (entry, { data }) => {
      const { name } = data;
      character.event[name]?.();
    },
  },
  playSequence: (spine, sequenceData) => {
    if (!sequenceData || sequenceData.length === 0) return;
    spine.state.setAnimation(0, sequenceData[0].name, sequenceData[0].loop);
    for (let i = 1; i < sequenceData.length; i++)
      spine.state.addAnimation(
        0,
        sequenceData[i].name,
        sequenceData[i].loop,
        sequenceData[i].delay
      );
  },
  initial: async (app, path) => {
    return new Promise((resolve, reject) => {
      const preload = new PIXI.Loader();
      preload.add("character_VND_008", path);
      preload.load(async (loader, resources) => {
        // console.log("resources", resources);
        if (app.loader.resources) {
          app.loader.resources.character_VND_008 = resources;
        }
        // console.log("app", app);
      });
      preload.onComplete.add(async () => {
        await StewardParticle.initial();
        resolve("load Steward complete");
      });
      preload.onError.add((e) => {
        reject(e);
      });
    });
  },
  create: async (app, audioRef, path, preload) => {
    return new Promise((resolve, reject) => {
      let promises = [
        new Promise((resolve, reject) => {
          // const preload = new PIXI.Loader();
          // preload.add("character", path);
          if (!preload.resources.character_VND_008) {
            preload.add("character_VND_008", path);
          }

          preload.load(async (loader, resources) => {
            let spineData =
              resources["character_VND_008"].character_VND_008.spineData;
            if (spineData) {
              let spine = new PIXISpine.Spine(spineData);
              spine.scale.set(character.scale);
              spine.state.addListener(character.eventListener);

              let container = new PIXI.Container();
              let animateContainer = new PIXI.Container();
              let emitterController;

              container.addChild(spine);
              container.addChild(animateContainer);

              await StewardParticle.load(app, animateContainer).then(
                (particle) => {
                  emitterController = particle;
                }
              );

              const controller = {
                spine,
                container,
                animateContainer,
                emitterController,
                targetPosition: {
                  x: 0,
                  y: 0,
                },
                moveSpeed: 100,
                isMoving: false,
                infoCharacter: {
                  characterName: "steward",
                },
                setActive: (isActive) => {
                  container.visible = isActive;
                },
                setTargetPosition: (x, y) => {
                  character.controller.targetPosition = {
                    x: x,
                    y: y,
                  };
                },
                setParticleActive: (isActive) => {},
                charging: () => {},
                setFiredBulletTo: async (targetPosition) => {
                  const delay = 0.35;
                  emitterController.animatedSprite.animateSteward.gotoAndPlay(
                    1
                  );

                  new Tweener(app.ticker)
                    .insert(
                      0.0 + delay,
                      new Tween(1, (pos, dt) => {
                        if (pos === 0) {
                          emitterController.animatedSprite.container.visible = true;
                          if (audioRef.current._group["VND-008"])
                            // console.log(audioRef.current._group);
                            audioRef.current._group["VND-008"]._list[0].play(
                              "attack"
                            );
                        }
                        if (pos === 1) {
                          emitterController.animatedSprite.container.visible = false;
                        } else {
                          emitterController.animatedSprite.container.position.x =
                            pos * (targetPosition.x - 80);
                          emitterController.animatedSprite.container.alpha =
                            1 - pos ** 8;
                        }
                      })
                    )
                    .insert(
                      0.0 + delay,
                      new Tween(0.6, (pos, dt) => {
                        if (pos === 1) {
                          if (audioRef.current._group["VND-008"])
                            // console.log(audioRef.current._group);
                            audioRef.current._group["VND-008"]._list[0].play(
                              "hitTarget"
                            );
                        }
                      })
                    )
                    .play();
                  await character.controller.routineWait(1.0).then(() => {
                    console.log("particle hit");
                  });
                },
                hurt: () => {},
                playState: (stateName) => {
                  if (character.sequence[stateName])
                    character.playSequence(
                      controller.spine,
                      character.sequence[stateName]
                    );
                },
                destroy: () => {
                  controller.spine.destroy();
                  controller.container?.destroy();
                },
                routineWait: async (second) => {
                  await new Promise((resolve) => {
                    const ticker = app.ticker;
                    let current = 0;
                    const onUpdate = (elapsedTime) => {
                      const deltaTime = (1 / ticker.FPS) * ticker.speed;
                      current += deltaTime;
                      if (current > second) {
                        ticker.remove(onUpdate);
                        resolve();
                      }
                    };
                    ticker.add(onUpdate);
                  });
                },
              };
              character.controller = controller;
              resolve(controller);
            } else {
              reject({ error: "NO_SPINE_DATA_STEWARD" });
            }
          });
        }),
      ];
      Promise.all(promises)
        .then((results) => {
          const [character] = results;
          resolve(character);
        })
        .catch((e) => {
          Sentry.captureException(e);
          reject(e);
        });
    });
  },
};

export default character;
